import { normalize, schema } from 'normalizr';
import { IMembersEntries } from '../../../members/types';
import { IMessagesEntries } from '../../../messages/types';
import { IPicture } from '../../../pictures/types';
import { IThreadsKeyList } from '../../../threads/types';
import { createMemberSchema } from '../../models/member/member.schema';
import { messageSchema } from '../../models/message';
import { pictureSchema } from '../../models/picture';
import { threadSchema } from '../../models/thread/thread.schema';
import { IApiThreadsResult, IThread } from '../../models/thread/thread.types';
import { memberSerializer } from '../helper';

const threadsSchema = new schema.Object({
  data: [threadSchema],
  included: new schema.Array(
    {
      member: createMemberSchema(memberSerializer),
      picture: pictureSchema,
      message: messageSchema,
    },
    'type'
  ),
});

export const threadsNormalizer = (
  threads: IApiThreadsResult
): INormalizedThreads => normalize(threads, threadsSchema);

export interface INormalizedThreads {
  entities: {
    threads: {
      [id: string]: IThread;
    };
    pictures: { [id: string]: IPicture };
    members: IMembersEntries;
    messages: IMessagesEntries;
  };
  result: {
    data: IThreadsKeyList;
    meta: {
      pagination: {
        current_page: number;
        total?: number;
      };
    };
  };
}
